(() => {
  let productImages = new Map();
  let productTitles = new Map();
  try {
    const data = JSON.parse(document.querySelector('[data-lmb-review-products]')?.textContent || '[]');
    productImages = new Map(data.map(({ handle, image }) => [handle, image]));
    productTitles = new Map(data.map((product) => [product.title, product]));
  } catch (_) {
    productImages = new Map();
  }

  const apply = (carousel) => {
    carousel.querySelectorAll('.jdgm-carousel-item__product-image[data-src]').forEach((image) => {
      const link = image.closest('a[href*="/products/"]');
      const product = productTitles.get(image.alt);
      const handle = product?.handle || link?.getAttribute('href')?.match(/\/products\/([^/#?]+)/)?.[1];
      const currentImage = productImages.get(handle);
      if (currentImage) {
        image.dataset.src = currentImage;
        image.dataset.srcRetina = currentImage;
        if (image.getAttribute('src') !== currentImage || image.hasAttribute('srcset')) {
          image.removeAttribute('srcset');
          image.src = currentImage;
        }
      } else {
        if (!image.getAttribute('src')) image.src = image.dataset.src;
        if (!image.dataset.lmbErrorBound) {
        image.dataset.lmbErrorBound = 'true';
        image.addEventListener('error', async () => {
          if (!handle || image.dataset.retried) { image.style.visibility = 'hidden'; return; }
          image.dataset.retried = 'true';
          try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}products/${handle}.js`);
            if (!response.ok) { image.style.visibility = 'hidden'; return; }
            const product = await response.json();
            if (product.featured_image) image.src = product.featured_image;
            else image.style.visibility = 'hidden';
          } catch (_) {
            image.style.visibility = 'hidden';
          }
        }, { once: true });
        }
      }
      image.loading = 'lazy';
      const container = image.closest('.jdgm-carousel-item__product');
      if (container && !container.querySelector('.lmb-review-card__product-label')) {
        const title = product?.title || image.alt;
        if (title) {
          const parts = title.replace(/&amp;/g, '&').split(/:\s*| - /);
          const label = document.createElement('span');
          label.className = 'lmb-review-card__product-label';
          const name = document.createElement('span');
          name.className = 'lmb-review-card__product-name';
          name.textContent = parts[0].replace(/\s+(Kollektion|Collection|Strandtuch|Beach towels)$/i, '');
          label.append(name);
          if (parts.length > 1) {
            const detail = document.createElement('span');
            detail.className = 'lmb-review-card__product-detail';
            detail.textContent = parts.slice(1).join(' · ');
            label.append(detail);
          }
          container.append(label);
        }
      }
    });
  };

  const connect = (carousel) => {
    apply(carousel);
    let frame = null;
    const observer = new MutationObserver(() => {
      if (frame !== null) return;
      frame = requestAnimationFrame(() => {
        frame = null;
        observer.disconnect();
        apply(carousel);
        observer.observe(carousel, { subtree: true, childList: true, attributes: true, attributeFilter: ['src'] });
      });
    });
    observer.observe(carousel, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['src']
    });
  };

  const prepare = (carousel) => {
    if (!('IntersectionObserver' in window)) { connect(carousel); return; }
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); connect(carousel); }
    }, { rootMargin: '600px' });
    observer.observe(carousel);
  };

  const ready = () => {
    const carousels = [...document.querySelectorAll('.jdgm-carousel-wrapper')];
    if (carousels.length) {
      carousels.forEach(prepare);
      return;
    }
    const observer = new MutationObserver(() => {
      const added = document.querySelector('.jdgm-carousel-wrapper');
      if (!added) return;
      observer.disconnect();
      prepare(added);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }
})();

